import api from '@/lib/api';

// Shapes from backend UserResource (/rest/user/personal-access-tokens).
export interface PersonalAccessTokenSummary {
  selector: string;
  name: string;
  scopes: string[];
  createdAt: string;
  expiresAt: string;
  revokedAt: string | null;
  lastUsedAt: string | null;
}

export interface CreatePersonalAccessTokenRequest {
  name: string;
  scopes: string[];
  expiresAt: string;
}

export interface CreatedPersonalAccessToken {
  token: string;
  selector: string;
  name: string;
  scopes: string[];
  createdAt: string;
  expiresAt: string;
}

const PATH = 'user/personal-access-tokens';

export async function listPersonalAccessTokens() {
  const { data } = await api.get<PersonalAccessTokenSummary[]>(PATH);
  return data;
}

export async function createPersonalAccessToken(request: CreatePersonalAccessTokenRequest) {
  const { data } = await api.post<CreatedPersonalAccessToken>(PATH, request);
  return data;
}

export async function revokePersonalAccessToken(selector: string) {
  const { data } = await api.delete<PersonalAccessTokenSummary>(
    `${PATH}/${encodeURIComponent(selector)}`
  );
  return data;
}
